import { render, staticRenderFns } from "./InventoryUnitDetails.vue?vue&type=template&id=d51138ae"
import script from "./InventoryUnitDetails.vue?vue&type=script&lang=js"
export * from "./InventoryUnitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports